<template>
  <MenuItem v-slot="{ active }">
    <component
      :is="component"
      :[attrName]="attrValue"
      :target="href ? '_blank' : null"
      :class="[
        active ? 'bg-neutral-100 dark:bg-neutral-700' : '',
        'px-3 py-1 text-sm leading-6 text-neutral-900 dark:text-neutral-100 cursor-pointer flex items-center whitespace-nowrap'
      ]">
      <span class="flex-1">{{ label }}</span>
      <i v-if="href" class="fa-sharp fa-regular fa-fw fa-external-link ml-3 text-neutral-400" aria-hidden="true"></i>
    </component>
  </MenuItem>
</template>

<script>
import { MenuItem } from '@headlessui/vue'

export default {
  components: { MenuItem },
  props: {
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    }
  },
  computed: {
    component() {
      if (this.href) {
        return 'a'
      }
      if (this.to) {
        return 'RouterLink'
      }

      return 'span'
    },
    attrName() {
      return this.to ? 'to' : 'href'
    },
    attrValue() {
      return this.to || this.href
    }
  }
}
</script>
